// src/services/api.ts
import axios from "axios";

// 1. Datamuse API (Free, No Key needed)
// Documentation: https://www.datamuse.com/api/
export const fetchKeywordSuggestions = async (seedKeyword: string) => {
  try {
    const response = await axios.get(`https://api.datamuse.com/words`, {
      params: {
        ml: seedKeyword, // 'ml' stands for 'means like' - good for SEO variations
        max: 20,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Datamuse API Error:", error);
    throw error;
  }
};

// 2. Google PageSpeed Insights API
// Get Key: https://developers.google.com/speed/docs/insights/v5/get-started
const GOOGLE_API_KEY = process.env.REACT_APP_API_KEY;

export const runPageSpeedAudit = async (
  url: string,
  strategy: "mobile" | "desktop" = "mobile"
) => {
  try {
    // We construct the URL manually to handle repeated 'category' params correctly
    // as some standard axios serializers add unwanted brackets (category[])
    const baseUrl = `https://www.googleapis.com/pagespeedonline/v5/runPagespeed`;
    const categories = [
      "performance",
      "accessibility",
      "best-practices",
      "seo",
    ];

    let queryParams = `?url=${encodeURIComponent(
      url
    )}&key=${GOOGLE_API_KEY}&strategy=${strategy}`;
    categories.forEach((cat) => {
      queryParams += `&category=${cat}`;
    });

    const response = await axios.get(`${baseUrl}${queryParams}`);
    return response.data;
  } catch (error) {
    console.error("PageSpeed API Error:", error);
    throw error;
  }
};
